import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'
import './lib/i18n' // Initialize i18n
import { initChunkLoadErrorHandler } from './utils/chunkLoadErrorHandler'

// Initialize global chunk load error handler for production
// This automatically retries or reloads when JS chunks fail to load
initChunkLoadErrorHandler();

ReactDOM.createRoot(document.getElementById('root')!).render( 
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
